var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"object-name":"GIS_T_ConnectResult__c","layout-name":"DetailLayout","default-title":"ArcGIS連携履歴","subtitle":"ArcGIS連携履歴","saved-page":"CDS_VF_GISConnectResultDetail","detail-page-name":"CDS_VF_GISConnectResultDetail","list-page":"CDS_VF_GISConnectResultList","list-view-props":{
    canSearch: false,
  },"can-edit":false,"disable-attachment":true,"use-version":false,"disable-actions":['edit', 'remove']}})
}
var staticRenderFns = []

export { render, staticRenderFns }